module.exports = __webpack_public_path__ + "assets/images/ios_push_notification-ef2debecc57081fb745a313dc34cf895.webm";